import { donationDeleted, donationsByUserId } from '@/entities/donations'
import { type DeleteApiDonationsByUserIdDonationsDonationidPathParams } from '@/shared/api'
import { ROUTES } from '@/shared/config'
import {
  ContentWrapper,
  ErrorResult,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { Breadcrumb, Flex, Layout, Typography } from 'antd'
import { useUnit } from 'effector-react'
import { Link, useParams } from 'react-router-dom'

import { DonationsByUserGate } from './model/donations-by-user-table.model'
import styles from './styles.module.scss'
import { DonationsByUserIdTable } from './ui/DonationsByUserIdTable'
import { DonationsByUserIdUserInfoCard } from './ui/DonationsByUserIdUserInfoCard'

export const DonationsByUserIdPage = () => {
  const { id } = useParams<{ id: string }>()
  const { data, pending, error } = useUnit(donationsByUserId)
  const deleteDonation = useUnit(donationDeleted)

  const onDelete = (
    id: DeleteApiDonationsByUserIdDonationsDonationidPathParams['Id'],
    donationId: DeleteApiDonationsByUserIdDonationsDonationidPathParams['DonationId'],
  ) => {
    deleteDonation({
      id,
      donationId,
    })
  }
  if (id) {
    return (
      <>
        <DonationsByUserGate id={id} />
        <HidingSpin spinning={pending || (!data && !error)}>
          <Layout className={styles.layout}>
            {data && !error ? (
              <>
                <HeaderContent
                  breadcrumbSlot={
                    <Breadcrumb
                      items={[
                        {
                          title: (
                            <Link to={ROUTES.DONATIONS.ROOT}>Эквайринг</Link>
                          ),
                        },
                        { title: 'Пользователи' },
                        { title: data.nickname },
                      ]}
                    />
                  }
                  title={data.nickname}
                  description="Раздел предоставляет возможность просматривать и редактировать донаты пользователя"
                />
                <ContentWrapper verticalPadding="small">
                  <Flex vertical gap={24}>
                    <Typography.Text className={styles.contentHeader}>
                      Общая информация
                    </Typography.Text>
                    <DonationsByUserIdUserInfoCard />
                    <Typography.Text className={styles.contentHeader}>
                      Список платежей
                    </Typography.Text>
                    <DonationsByUserIdTable userId={id} onDelete={onDelete} />
                  </Flex>
                </ContentWrapper>
              </>
            ) : (
              <ContentWrapper>
                <ErrorResult
                  error={error}
                  notFoundConfig={{
                    subTitle: 'Данного пользователя не существует.',
                    navigateTo: ROUTES.DONATIONS.ROOT,
                  }}
                />
              </ContentWrapper>
            )}
          </Layout>
        </HidingSpin>
      </>
    )
  } else {
    return (
      <ErrorResult
        error={error}
        notFoundConfig={{
          subTitle: 'Данного пользователя не существует.',
          navigateTo: ROUTES.DONATIONS.ROOT,
        }}
      />
    )
  }
}
